import { readJson, writeJson } from './storage';

/**
 * One-time explanations the player has already seen: the campaign and Long Night guides, the pawn
 * ticket tip and the Long Night's first table tip.
 */
export type GuideName = 'campaign' | 'ticket' | 'night' | 'night-table' | 'broker-counter';

const NAMES: readonly GuideName[] = [
  'campaign',
  'ticket',
  'night',
  'night-table',
  'broker-counter',
];

const KEY = 'guides.v1';

const load = (): GuideName[] =>
  readJson(KEY, (v) =>
    Array.isArray(v) ? v.filter((x): x is GuideName => NAMES.includes(x as GuideName)) : null,
  ) ?? [];

export const guideSeen = (name: GuideName): boolean => load().includes(name);

export function markGuideSeen(name: GuideName): void {
  const seen = load();
  if (!seen.includes(name)) writeJson(KEY, [...seen, name]);
}
